






// @ is an alias to /src
import {Component, Mixins} from "vue-property-decorator";
import MovingList from "@/components/contract-moving/movingList.vue";
import Authority from "@/common/mixins/authority";
@Component({
  name: "ContractMovingListPage",
  components: {
    MovingList,
  },
})
export default class ContractMovingListPage extends Mixins(Authority) {}
